'use strict';

var _ = require('lodash');
var moment = require('moment');
var AbstractROMServiceAggregationFactory = function AbstractROMServiceAggregationFactory(DataAggregationFactory) {
  function AbstractROMServiceAggregation() {
    DataAggregationFactory.apply(this, arguments);
  }
  AbstractROMServiceAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  AbstractROMServiceAggregation.constructor = AbstractROMServiceAggregation;
  AbstractROMServiceAggregation.prototype.getMetricValue = function (v, metrics, doRounding) {
    if (metrics.length === 0) {
      return;
    }
    if (metrics.length === 1) {
      return v[metrics[0]];
    }
    var metricValue = v[metrics[0]] + v[metrics[1]];
    return doRounding ? preventNegativeZeroRounding(metricValue) : metricValue;
  };
  function preventNegativeZeroRounding(m) {
    var roundedValue = Math.round(m);
    return roundedValue === -0 ? 0 : roundedValue;
  }

  /**
   * Get combined metric value
   *
   * @param v1, v2, v3, ... - values, that should be multiplied based on metric
   * @param metrics - last argumet
   * @returns {Number} calculated value
   */
  AbstractROMServiceAggregation.prototype.getCombinedMetricValue = function () {
    var values = [].slice.call(arguments);
    var metrics = values.pop();

    // do sum here for all metrics
    return metrics.reduce(function (previousMetric, currentMetric) {
      // multiply values (v1 * v2 * v3 * ... etc)
      return previousMetric + values.reduce(function (previousValue, currentValue) {
        return previousValue[currentMetric] * currentValue[currentMetric];
      });
    }, 0);
  };
  AbstractROMServiceAggregation.prototype.lastOptGroupWeekData = function (grouped) {
    var groupedKeys = Object.keys(grouped);
    groupedKeys.sort(function (a, b) {
      return moment.utc(a).diff(moment.utc(b));
    });
    var lastOptGroupWeek = _.last(groupedKeys);
    return {
      data: grouped[lastOptGroupWeek],
      week: lastOptGroupWeek
    };
  };

  /**
   *
   * @param data
   * @param field
   * @param type - sorting type ( 'ASC' is default)
   * @returns {Array} sorted array
   */
  AbstractROMServiceAggregation.prototype.sortBy = function (data, field, type) {
    type = type || 'ASC';
    return data.sort(function (a, b) {
      if (a[field] < b[field]) {
        return type === 'ASC' ? -1 : type === 'DESC' ? 1 : 0;
      } else if (a[field] > b[field]) {
        return type === 'ASC' ? 1 : type === 'DESC' ? -1 : 0;
      } else {
        return 0;
      }
    });
  };
  function prepareDataWithRank(context, data, limit) {
    var clonedData = _.cloneDeep(data);
    context.sortBy(clonedData, 'rank', 'ASC').splice(limit, data.length - limit);
    return clonedData;
  }
  function prepareDataWithoutRank(context, data, limit) {
    var clonedData = _.cloneDeep(data);
    context.sortBy(clonedData, 'revGap', 'DESC').splice(limit, data.length - limit);
    return clonedData.map(function (item) {
      item.rank = 'N/A';
      return item;
    });
  }

  /**
   *
   * @param data
   * @param field - sort by field
   * @param type - 'DESC' or 'ASC'
   * @param limit - amount of array elements to get
   * @returns {{data: *, week: *}} - object with optWeek and related data
   */
  AbstractROMServiceAggregation.prototype.topOppAggregate = function (data, limit) {
    var groupBy = 'optGroupWeek';
    var grouped = data.reduce(function (grouped, item) {
      (grouped[item[groupBy]] = grouped[item[groupBy]] || []).push(item);
      return grouped;
    }, {});
    var lastGrouped = this.lastOptGroupWeekData(grouped);
    limit = _.isFinite(limit) ? limit : lastGrouped.data.length;
    var topOptData = _.isUndefined(lastGrouped.data[0].rank) ? prepareDataWithoutRank(this, lastGrouped.data, limit) : prepareDataWithRank(this, lastGrouped.data, limit);
    return {
      data: topOptData,
      week: lastGrouped.week
    };
  };
  AbstractROMServiceAggregation.prototype.aggregateWithMetrics = function (data, metricsKeys) {
    var aggregated = [];
    for (var index = 0, dataLength = data.length; index < dataLength; index++) {
      var week = data[index];
      var weekKeys = Object.keys(week.week);
      for (var weekIndex = 0, weekLength = weekKeys.length; weekIndex < weekLength; weekIndex++) {
        var dow = weekKeys[weekIndex];
        var day = week.week[dow];
        for (var metricIndex = 0, metricLength = metricsKeys.length; metricIndex < metricLength; metricIndex++) {
          var metricKey = [metricsKeys[metricIndex]];
          aggregated.push({
            cabin: week.cabin,
            week: week.optWeek,
            date: week.optWeekDateMoment,
            d2dBucket: week.romTimeBucket,
            pos: week.spos,
            dow: day.dow,
            fullDow: day.fullDow,
            optGroupWeek: day.optGroupWeek,
            actRecapture: this.getMetricValue(day.actualRecaptureRevenue, metricKey),
            actRevenue: this.getMetricValue(day.actualRevenue, metricKey),
            actSpill: this.getMetricValue(day.actualSpillRevenue, metricKey),
            maxRecapture: this.getMetricValue(day.maxRecaptureRevenue, metricKey),
            maxRevenue: this.getMetricValue(day.maxRevenue, metricKey),
            maxSpill: this.getMetricValue(day.maxSpillRevenue, metricKey),
            minRevenue: this.getMetricValue(day.minRevenue, metricKey),
            fcDemand: this.getMetricValue(day.fcDemand, metricKey),
            actSale: this.getMetricValue(day.actualSale, metricKey),
            maxSale: this.getMetricValue(day.maxSale, metricKey),
            actOpenFcDemand: this.getCombinedMetricValue(day.actualOpenPct, day.fcDemand, metricKey),
            maxOpenFcDemand: this.getCombinedMetricValue(day.maxOpenPct, day.fcDemand, metricKey),
            resType: _.startCase(metricsKeys[metricIndex])
          });
        }
      }
    }
    return aggregated;
  };
  return AbstractROMServiceAggregation;
};
AbstractROMServiceAggregationFactory.$inject = ['DataAggregationFactory'];
module.exports = AbstractROMServiceAggregationFactory;